import { useState } from "react";
import DoctorDataTable from "../../components/doctors/DoctorDataTable";
import PharmacyDataTable from "../../components/Pharmacy/PharmacyDataTable"
import "../../assets/css/doctor.scss";
import '../../assets/css/pharmacy.scss'
import { Button, Modal, Rate, Select, Slider } from "antd";

// img svg
import RightArrow from "../../assets/images/doctor/RightArrow.svg";
import FilterIcon from "../../assets/images/doctor/FilterIcon.svg";
import DownTriIcon from "../../assets/images/doctor/DownTriIcon.svg";
import { Link } from "react-router-dom";
import CustomSelect from "../../components/common/CustomSelect";
import Searchbar from "../../components/common/Searchbar";

const Pharmacy = () => {

    const [rows, setRows] = useState([
        {
            number: 1,
            name: "Sohaib Butt",
            email: "johndoe@example.com",
            age: 35,
            gender: "male",
            specialization: "Cardiology",
            date: "2023-03-25",
            time: "11:00AM",
            civilID: "40122-67366475-3",
            doctor: "Dr. Jane Smith",
            fees: "$50/Patient",
            appointmentStatus: "Pending",
            prescription: "Aspirin 500mg",
        },
        {
            number: 2,
            name: "Abdullah",
            email: "johndoe@example.com",
            age: 35,
            gender: "male",
            specialization: "Cardiology",
            date: "2023-03-25",
            time: "11:00AM",
            civilID: "40122-67366475-4",
            doctor: "Dr. Jane Smith",
            fees: "$50/Patient",
            appointmentStatus: "Pending",
            prescription: "Aspirin 500mg",
        },
        {
            number: 3,
            name: "Ahad",
            email: "johndoe@example.com",
            age: 35,
            gender: "male",
            specialization: "Cardiology",
            date: "2023-03-25",
            time: "11:00AM",
            civilID: "40122-67366475-5",
            doctor: "Dr. Jane Smith",
            fees: "$50/Patient",
            appointmentStatus: "Pending",
            prescription: "Aspirin 500mg",
        },
        {
            number: 4,
            name: "Azlan",
            email: "johndoe@example.com",
            age: 35,
            gender: "male",
            specialization: "Cardiology",
            date: "2023-03-25",
            time: "11:00AM",
            civilID: "40122-67366475-6",
            doctor: "Dr. Jane Smith",
            fees: "$50/Patient",
            appointmentStatus: "Pending",
            prescription: "Aspirin 500mg",
        },
        {
            number: 5,
            name: "Ayan",
            email: "johndoe@example.com",
            age: 35,
            gender: "male",
            specialization: "Cardiology",
            date: "2023-03-25",
            time: "11:00AM",
            civilID: "40122-67366475-7",
            doctor: "Dr. Jane Smith",
            fees: "$50/Patient",
            appointmentStatus: "Pending",
            prescription: "Aspirin 500mg",
        },
        {
            number: 6,
            name: "Sohaib",
            email: "johndoe@example.com",
            age: 35,
            gender: "male",
            specialization: "Cardiology",
            date: "2023-03-26",
            time: "11:00AM",
            civilID: "40122-67366475-7",
            doctor: "Dr. Jane Smith",
            fees: "$50/Patient",
            appointmentStatus: "Pending",
            prescription: "Aspirin 500mg",
        },
        {
            number: 7,
            name: "Caliph",
            email: "johndoe@example.com",
            age: 35,
            gender: "male",
            specialization: "Cardiology",
            date: "2023-03-26",
            time: "11:00AM",
            civilID: "40122-67366475-7",
            doctor: "Dr. Jane Smith",
            fees: "$50/Patient",
            appointmentStatus: "Approved",
            prescription: "Aspirin 500mg",
        },
        {
            number: 8,
            name: "Johnson",
            email: "johndoe@example.com",
            age: 35,
            gender: "male",
            specialization: "Cardiology",
            date: "2023-03-26",
            time: "11:00AM",
            civilID: "40122-67366475-7",
            doctor: "Dr. Jane Smith",
            fees: "$50/Patient",
            appointmentStatus: "Approved",
            prescription: "Aspirin 500mg",
        },
        {
            number: 9,
            name: "William",
            email: "johndoe@example.com",
            age: 35,
            gender: "male",
            specialization: "Cardiology",
            date: "2023-03-26",
            time: "11:00AM",
            civilID: "40122-67366475-7",
            doctor: "Dr. Jane Smith",
            fees: "$50/Patient",
            appointmentStatus: "Approved",
            prescription: "Aspirin 500mg",
        },
        {
            number: 10,
            name: "Sufiyan",
            email: "johndoe@example.com",
            age: 35,
            gender: "male",
            specialization: "Cardiology",
            date: "2023-03-26",
            time: "11:00AM",
            civilID: "40122-67366475-7",
            doctor: "Dr. Jane Smith",
            fees: "$50/Patient",
            appointmentStatus: "Approved",
            prescription: "Aspirin 500mg",
        },
        {
            number: 11,
            name: "Malok",
            email: "johndoe@example.com",
            age: 35,
            gender: "male",
            specialization: "Cardiology",
            date: "2023-03-26",
            time: "11:00AM",
            civilID: "40122-67366475-7",
            doctor: "Dr. Jane Smith",
            fees: "$50/Patient",
            appointmentStatus: "Approved",
            prescription: "Aspirin 500mg",
        },
        {
            number: 12,
            name: "Asad",
            email: "johndoe@example.com",
            age: 35,
            gender: "male",
            specialization: "Cardiology",
            date: "2023-03-26",
            time: "11:00AM",
            civilID: "40122-67366475-7",
            doctor: "Dr. Jane Smith",
            fees: "$50/Patient",
            appointmentStatus: "pending",
            prescription: "Aspirin 500mg",
        },
        {
            number: 13,
            name: "Umair",
            email: "johndoe@example.com",
            age: 35,
            gender: "male",
            specialization: "Cardiology",
            date: "2023-03-26",
            time: "11:00AM",
            civilID: "40122-67366475-7",
            doctor: "Dr. Jane Smith",
            fees: "$50/Patient",
            appointmentStatus: "Approved",
            prescription: "Aspirin 500mg",
        },
        {
            number: 14,
            name: "Dan",
            email: "johndoe@example.com",
            age: 35,
            gender: "male",
            specialization: "Cardiology",
            date: "2023-03-26",
            time: "11:00AM",
            civilID: "40122-67366475-7",
            doctor: "Dr. Jane Smith",
            fees: "$50/Patient",
            appointmentStatus: "Approved",
            prescription: "Aspirin 500mg",
        },
        {
            number: 15,
            name: "Dan",
            email: "johndoe@example.com",
            age: 35,
            gender: "male",
            specialization: "Cardiology",
            date: "2023-03-26",
            time: "11:00AM",
            civilID: "40122-67366475-7",
            doctor: "Dr. Jane Smith",
            fees: "$50/Patient",
            appointmentStatus: "Approved",
            prescription: "Aspirin 500mg",
        },
        {
            number: 16,
            name: "Dan",
            email: "johndoe@example.com",
            age: 35,
            gender: "male",
            specialization: "Cardiology",
            date: "2023-03-24",
            time: "11:00AM",
            civilID: "40122-67366475-7",
            doctor: "Dr. Jane Smith",
            fees: "$50/Patient",
            appointmentStatus: "Approved",
            prescription: "Aspirin 500mg",
        },
        {
            number: 17,
            name: "Dan",
            email: "johndoe@example.com",
            age: 35,
            gender: "male",
            specialization: "Cardiology",
            date: "2023-03-24",
            time: "11:00AM",
            civilID: "40122-67366475-7",
            doctor: "Dr. Jane Smith",
            fees: "$50/Patient",
            appointmentStatus: "Approved",
            prescription: "Aspirin 500mg",
        },
        {
            number: 18,
            name: "Dan",
            email: "johndoe@example.com",
            age: 35,
            gender: "male",
            specialization: "Cardiology",
            date: "2023-03-24",
            time: "11:00AM",
            civilID: "40122-67366475-7",
            doctor: "Dr. Jane Smith",
            fees: "$50/Patient",
            appointmentStatus: "Approved",
            prescription: "Aspirin 500mg",
        },
        {
            number: 19,
            name: "Dan",
            email: "johndoe@example.com",
            age: 35,
            gender: "male",
            specialization: "Cardiology",
            date: "2023-03-24",
            time: "11:00AM",
            civilID: "40122-67366475-7",
            doctor: "Dr. Jane Smith",
            fees: "$50/Patient",
            appointmentStatus: "Approved",
            prescription: "Aspirin 500mg",
        },
        {
            number: 20,
            name: "Sameer",
            email: "johndoe@example.com",
            age: 35,
            gender: "male",
            specialization: "Cardiology",
            date: "2023-03-24",
            time: "11:00AM",
            civilID: "40122-67366475-7",
            doctor: "Dr. Jane Smith",
            fees: "$50/Patient",
            appointmentStatus: "Approved",
            prescription: "Aspirin 500mg",
        },
    ]);
    const [filterOption, setFilterOption] = useState("today"); // default to "today"
    const [searchQuery, setSearchQuery] = useState("");

    //  Filter handler
    const handleFilterChange = (event) => {
        setFilterOption(event.target.value);

    };

    // Search Functionality
    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
    };

    const [modal2Open, setModal2Open] = useState(false);
    const [modal1Open, setModal1Open] = useState(false);

    const marks = {
        // 0: '0°C',
        15: "0 Km",
        65: "500 km",
        100: {
            style: {
                color: "#f50",
            },
            // label: <strong>100°C</strong>,
        },
    };

    const marks1 = {
        // 0: '0°C',
        15: "$ 50",
        65: "$ 300",
        100: {
            style: {
                color: "#f50",
            },
            // label: <strong>100°C</strong>,
        },
    };

    return (
        <>
            <div className="row  px-2 pt-4">
                <div className="col-12  ">
                    <p className="mb-0 dashboard-com-top-text">Pharmacy List</p>
                </div>

                <div className="col-12  ">
                    <div className="row d-flex align-items-end">
                        <div className="col-lg-6 col-12 mt-lg-0 mt-2">
                            <p className="mb-0 doctor-header-top-text">
                                <Link className="doc-link " to="">
                                    DASHBOARD
                                </Link>
                                <img className="mx-lg-3 ml-2 pr-1 pb-1" src={RightArrow} alt="" />{" "}
                                <Link className="doc-link " to="pharmacy">
                                    <span>PHARMACY</span>{" "}
                                </Link>
                                <img className="mx-lg-3 ml-2 pr-1 pb-1" src={RightArrow} alt="" />{" "}
                                <span style={{ color: "#4FA6D1" }}>PHARMACY LIST</span>{" "}
                            </p>
                        </div>

                        <div className="col-lg-6 col-12 mt-lg-0 mt-3 d-flex justify-content-end ">
                            <button onClick={() => setModal2Open(true)} className="btn-add-new-doc mr-2"> Add a Role </button>{" "}

                            <button onClick={() => setModal1Open(true)} className="btn-add-new-doc"> Add Pharmacy </button>{" "}

                        </div>

                        <Modal
                            className="doctor-filter-modal"
                            centered
                            open={modal2Open}
                            // onOk={() => setModal2Open(false)}
                            onCancel={() => setModal2Open(false)}
                            width={681}
                            footer={
                                <div className="row px-3 mt-4 mb-2">


                                    <div className="col-12 d-flex justify-content-center mt-3">
                                        <button className="apply-filter submit-pharmacy-role">Submit</button>
                                    </div>
                                </div>
                            }
                        >
                            <div className="row px-3 border-bottom">
                                <div className="col-12 ">
                                    <p className="doc-add-filter">Add a Role</p>
                                </div>
                            </div>

                            <div className="row px-3 mt-4">
                                <div className="col-lg-6 doc-setting-input">
                                    <p className=" doc-add-filter-text">Role Type</p>

                                    <input type="text" placeholder="Pharmacist" />
                                </div>

                                <div className="col-lg-6 mt-lg-0  mt-4  doc-setting-input">
                                <p className=" doc-add-filter-text">
                                Hospital <span style={{ color: "#8C8C8C" }}>(Optional)</span>
                                </p>

                                    <Select
                                        defaultValue="Select"
                                        style={{
                                            width: "100%",
                                        }}
                                        onChange={() => { }}
                                        options={[
                                            {
                                                label: "Cardiology0​​",
                                                value: "Cardiology0"
                                            },
                                            {
                                                label: "Neurology",
                                                value: "Neurology"
                                            },
                                            {
                                                label: "Cardiology​​",
                                                value: "Cardiology"
                                            },
                                            {
                                                label: "Neurology1",
                                                value: "Neurology1"
                                            },
                                        ]}
                                    />
                                </div>
                            </div>

                            <div className="row px-3 mt-4">
                                <div className="col-lg-12 doc-setting-input">
                                    <p className=" doc-add-filter-text">Name</p>

                                    <input type="text" />
                                </div>


                            </div>

                            <div className="row px-3 mt-4">
                                <div className="col-lg-12 doc-setting-input">
                                    <p className=" doc-add-filter-text">Email</p>

                                    <input type="text" />
                                </div>
                            </div>

                            <div className="row px-3 mt-4">


                                <div className="col-lg-12 mt-lg-1 mt-0 doc-setting-input">
                                    <p className=" doc-add-filter-text">City</p>

                                    <Select
                                        defaultValue="Select"
                                        style={{
                                            width: "100%",
                                        }}
                                        onChange={() => { }}
                                        options={[
                                            {
                                                label: "Cardiology​​",
                                                value: "Cardiology"
                                            },
                                            {
                                                label: "Neurology",
                                                value: "Neurology"
                                            },
                                            {
                                                label: "Cardiology1​​",
                                                value: "Cardiology1"
                                            },
                                            {
                                                label: "Neurology1",
                                                value: "Neurology1"
                                            },
                                        ]}
                                    />
                                </div>
                            </div>

                            <div className="row px-3 mt-4">
                                <div className="col-lg-6 doc-setting-input">
                                    <p className=" doc-add-filter-text">Contact</p>

                                    <input type="text" />
                                </div>

                                <div className="col-lg-6 mt-lg-0 mt-4 doc-setting-input">
                                    <p className=" doc-add-filter-text">State</p>

                                    <CustomSelect
                                        defaultValue="Select"
                                        style={{
                                            width: "100%",
                                        }}
                                        onChange={() => { }}
                                        options={[
                                            {
                                                label: "Cardiology​​",
                                                value: "Cardiology"
                                            },
                                            {
                                                label: "Neurology",
                                                value: "Neurology"
                                            },
                                            {
                                                label: "Cardiology1​​",
                                                value: "Cardiology1"
                                            },
                                            {
                                                label: "Neurology1",
                                                value: "Neurology1"
                                            },
                                        ]}
                                    />
                                </div>
                            </div>
                        </Modal>



                        <Modal
                            className="doctor-filter-modal"
                            centered
                            open={modal1Open}
                            // onOk={() => setModal2Open(false)}
                            onCancel={() => setModal1Open(false)}
                            width={1046}
                            footer={
                                <div className="row px-3 mt-4 mb-4">
                                    <div className="col-12 pt-3 pb-2 d-flex justify-content-center mt-3">
                                        <button className="apply-filter submit-pharmacy-add">Register</button>
                                    </div>
                                </div>
                            }
                        >
                            <div className="row px-3 border-bottom">
                                <div className="col-12 ">
                                    <p className="doc-add-filter">Add a Pharmacy</p>
                                </div>
                            </div>


                            <div className="row px-3 mt-4">
                                <div className="col-lg-12 doc-setting-input">
                                    <p className=" doc-add-filter-text">Name</p>

                                    <input type="text" />
                                </div>


                            </div>

                            <div className="row px-3 mt-4">
                                <div className="col-lg-12 doc-setting-input">
                                    <p className=" doc-add-filter-text">Phone No</p>

                                    <input type="text" />
                                </div>
                            </div>
                            <div className="row px-3 mt-4">
                                <div className="col-lg-12 doc-setting-input">
                                    <p className=" doc-add-filter-text">Email <span style={{ color: "#8C8C8C" }}>(Optional)</span></p>

                                    <input type="text" />
                                </div>
                            </div>

                            <div className="row px-3 mt-4">
                                <div className="col-lg-12 doc-setting-input">
                                    <p className=" doc-add-filter-text">Address</p>

                                    <input type="text" />
                                </div>
                            </div>



                            <div className="row px-3 mt-4">
                                <div className="col-lg-4 pr-lg-0 doc-setting-input">
                                    <p className=" doc-add-filter-text">Country </p>

                                    <input type="text" placeholder="Choose" />
                                </div>

                                <div className="col-lg-4 pt-lg-0 pt-4 doc-setting-input">
                                    <p className=" doc-add-filter-text ">State</p>

                                    <input type="text" placeholder="Choose" />
                                </div>

                                <div className="col-lg-4 pt-lg-0 pt-4 pl-lg-0 doc-setting-input">
                                    <p className=" doc-add-filter-text">Zip</p>

                                    <input type="text" />
                                </div>


                            </div>
                        </Modal>


                    </div>
                </div>

                <div className="col-12  ">

                    <div className="row mb-5 pb-5">

                        <div className="col-12  pb-2 d-flex justify-content-start">
                            <Searchbar onChange={handleSearchChange} value={searchQuery} placeholder='Search' />
                        </div>

                        <div className="col-12 px-2">
                            <PharmacyDataTable
                                rows={rows}

                                searchQuery={searchQuery}
                            />
                        </div>

                    </div>

                </div>
            </div>
        </>
    )
}

export default Pharmacy